// cSpell:enableCompoundWords
import { ASButton, ComponentSize } from '@eleventheye/asui';
import EditTeam from 'app/scenes/statsmanager/components/team/components/editteam';
import { UseEditTeam } from 'app/scenes/statsmanager/components/team/useEditTeam';
import React from 'react';
import styles from './EditTeamPanel.module.scss';

type EditTeamPanelProps = {
  className?: string;
  editHook: UseEditTeam;
};

const EditTeamPanel: React.FC<EditTeamPanelProps> = ({ className = '', editHook }) => {
  const baseCls = `${styles.EditTeamPanelContainer} ${className}`;
  return (
    <div className={baseCls}>
      <EditTeam
        teamFullName={editHook.teamFullName}
        setTeamFullName={editHook.setTeamFullName}
        teamCity={editHook.teamCity}
        setTeamCity={editHook.setTeamCity}
        teamState={editHook.teamState}
        setTeamState={editHook.setTeamState}
        teamStadium={editHook.teamStadium}
        setTeamStadium={editHook.setTeamStadium}
        stadiumCapacity={editHook.stadiumCapacity}
        setStadiumCapacity={editHook.setStadiumCapacity}
        selectedConference={editHook.selectedConference}
        setSelectedConference={editHook.setSelectedConference}
        selectedDivision={editHook.selectedDivision}
        setSelectedDivision={editHook.setSelectedDivision}
        teamStadiumHasRoof={editHook.teamStadiumHasRoof}
        setTeamStadiumHasRoof={editHook.setTeamStadiumHasRoof}
        teamStadiumFieldType={editHook.teamStadiumFieldType}
        setTeamStadiumFieldType={editHook.setTeamStadiumFieldType}
        teamRivalries={editHook.teamRivalries}
        setTeamRivalries={editHook.setTeamRivalries}
        disabledTeams={editHook.disabledTeams}
      />
      <div className={styles.EditTeamPanelActionButtons}>
        <ASButton size={ComponentSize.Medium} onTapped={() => editHook.setEditMode(false)}>
          Cancel
        </ASButton>
        <ASButton disabled={!editHook.isDirty} size={ComponentSize.Medium} onTapped={editHook.onUpdateTeamInfo}>
          Update
        </ASButton>
      </div>
    </div>
  );
};

export default EditTeamPanel;
